import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'DateFilter',
  standalone: false,
})
/**
 * Usage:
 * valid params lte, lt, eq, gt, gte
 *
 * DateFilter: 'field': type : value
 *
 * value = a date object.
 *
 * ts file:
 *
 * var searchDate = new Date();
 *
 * <tr *ngFor="let item of mf.data | DateFilter:'Until':'lte':searchDate:showNull">
 */
export class DateFilter implements PipeTransform {
  transform(
    values: Array<Record<string, unknown>>,
    key: string,
    type: string,
    args: Date | null | undefined,
    showNull: boolean
  ): Array<Record<string, unknown>> {
    return values.filter((value) => {
      if (args == undefined) {
        return true;
      }

      if (args) {
        if (value && value.hasOwnProperty(key)) {
          const currentValue = value[key];
          //if there is a null or undefined value dont show it
          if (!currentValue && showNull == false) return false;
          else if (showNull == true && !currentValue) {
            return true;
          } else if (currentValue instanceof Date && args instanceof Date) {
            const tempDate = new Date(
              currentValue.getFullYear(),
              currentValue.getMonth(),
              currentValue.getDate(),
              0,
              0,
              0
            );

            if (type == 'lt') {
              if (tempDate < args) return true;
              else return false;
            } else if (type == 'lte') {
              if (tempDate <= args) return true;
              else return false;
            } else if (type == 'gt') {
              if (tempDate > args) return true;
              else return false;
            } else if (type == 'gte') {
              if (tempDate >= args) return true;
              else return false;
            } else if (type == 'eq') {
              if (tempDate >= args) return true;
              else return false;
            }
          }
        }
      }

      return true;
    });
  }
}
